export default function CustomController($scope, $state, $q, $translate, DataService, MapService, TitleService, NotificationService) {
	"ngInject";

	const vm = this;

	vm.$onInit = () => {
		vm.customId = $state.params.customId;
		vm.loading = true;

		DataService.getCustom(vm.customId).then((custom) => {
			TitleService.setTitleOrg(custom);

			vm.custom = custom;
			vm.map = DataService.instantMap();
			vm.recenter();

			DataService.setMapOpts({selectedOrg: vm.custom, automaticOrgs: vm.custom});

			vm.loading = false;
		}, NotificationService.exception(vm));

		DataService.getAllCustoms().then((customs) => {
			vm.customs = customs;
			DataService.updateMapOpts({automaticOrgs: vm.custom});
		});
	};

	vm.recenter = () => {
		MapService.centerMap(vm.custom, vm.map);
	};


	vm.editCustom = () => {
		$state.go("custom-edit", {customId: vm.customId});
	};

	vm.addCustom = () => {
		$state.go("custom-create");
	};
}
